module.exports = __webpack_public_path__ + "img/logo-aiaibot.6b003fa6.svg";